import React, { useState } from 'react';
import ConfirmationModal from '../../elements/ConfirmationModal';
import { SecondaryTabsTestCases } from '../../elements/SecondaryTabs';
import FileImportComponent from '../../elements/file-import/FileImportComponent';
import {
  archiveTestCase,
  bulkCreateTestCase,
} from '../../../modules/entity-details';
import { deleteTestCase } from '../../../modules/entity-details';
import { useNotification } from '../../../hooks/NotificationContext';
import FileExportComponent from '../../elements/file-export';
import { Typography } from '@mui/material';

const TestCaseTableActions = ({
  handleOpenTestCaseModal,
  seletectItems,
  showArchived,
  isSelectedItems,
  selectedRows,
  setShowArchived,
  refreshData,
  projectId,
  handleBulkEditModal,
  setSelected,
  fetchTestCaseData,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showArchiveWarning, setShowArchiveWarning] = useState(false);
  const { addNotification } = useNotification();

  const handleArchiveTestcase = async (type) => {
    try {
      await archiveTestCase({ testcases: seletectItems, type });

      addNotification('success', `Test case(s) ${type} successfully!`);
      refreshData();
      setShowArchiveWarning(false);
    } catch (error) {
      const errorMessage =
        error?.message ||
        'Failed to archive test case. Please try again later.';
      addNotification('danger', errorMessage);
    }
  };

  const handleDeleteTestcase = async () => {
    try {
      await deleteTestCase({ testcases: seletectItems });

      addNotification('success', 'Test case(s) deleted successfully!');
      refreshData();
      setShowConfirmationModal(false);
    } catch (error) {
      const errorMessage =
        error?.message || 'Failed to delete test case. Please try again later.';
      addNotification('danger', errorMessage);
    }
  };

  const handleCloneTestcase = async () => {
    const clonedTestCases = selectedRows?.map((testcase) => testcase.id)
    const payload = {
      testcaseIds: clonedTestCases,
    };
    try {
      await bulkCreateTestCase(payload, projectId);

      refreshData();
      addNotification('success', 'Test case(s) cloned successfully!');
    } catch (error) {
      const errorMessage =
        error?.message || 'Failed to clone test case. Please try again.';
      addNotification('danger', errorMessage);
    }
  };

  const handleCloseModal = () => {
    setShowConfirmationModal(false);
  };

  const [modalShow, setModalShow] = useState(false);
  const [exportModalShow, setExportModalShow] = useState(false);

  const handleOpenExportModal = () => setExportModalShow(true);
  const handleCloseExportModal = () => setExportModalShow(false);

  const handleModalClose = () => setModalShow(false);
  const handleModalShow = () => setModalShow(true);

  return (
    <>
      <SecondaryTabsTestCases
        handleOpenTestCaseModal={handleOpenTestCaseModal}
        handleArchiveTestcase={handleArchiveTestcase}
        showArchived={showArchived}
        isSelectedItems={isSelectedItems}
        fetchTestCases={refreshData}
        handleCloneTestcase={handleCloneTestcase}
        setShowArchived={setShowArchived}
        setShowConfirmationModal={setShowConfirmationModal}
        handleModalShow={handleModalShow}
        handleOpenExportModal={handleOpenExportModal}
        setShowArchiveWarning={setShowArchiveWarning}
        handleBulkEditModal={handleBulkEditModal}
      />
      <ConfirmationModal
        show={showArchiveWarning}
        handleClose={() => setShowArchiveWarning(false)}
        handleConfirm={() => handleArchiveTestcase('archived')}
        title="Archive test case"
        body={
          <div>
            <Typography color='red' variant="body2" sx={{mb: 2}}>{seletectItems?.length} test case(s) will be archived.</Typography>
            Archiving the test case(s) will remove them from all test suites and
            mark them as ARCHIVED.
            Archived test cases cannot be linked to test cycles or executed.
            <p>This action cannot be undone.</p>
            <strong>Are you sure you want to archive the selected test case(s)?</strong>
          </div>
        }
        buttonLabel="Archive"
      />
      <ConfirmationModal
        show={showConfirmationModal}
        handleClose={handleCloseModal}
        handleConfirm={handleDeleteTestcase}
        title="Delete test case"
        body={
          <div>
            Deleting the test case(s) will permanently remove the following:
            <span>
              <li>All associated test steps</li>
              <li>Executions from all test cycles</li>
              <li>Comments and attachments</li>
              <li>Any other related data</li>
            </span>
            <span>This action cannot be undone.</span>
            <strong>Are you sure you want to delete the test case(s)?</strong>
          </div>
        }
        buttonLabel="Delete"
      />
      <FileImportComponent
        show={modalShow}
        handleClose={handleModalClose}
        fetchTestCases={refreshData}
        projectId={projectId}
        fetchTestCaseData={fetchTestCaseData}
      />
      <FileExportComponent
        show={exportModalShow}
        handleClose={handleCloseExportModal}
        fetchTestCases={refreshData}
        projectId={projectId}
        selectedTestcases={selectedRows}
      />
    </>
  );
};

export default TestCaseTableActions;
